// inv/src/components/ui/dialog.jsx
import { Button } from "./button";
import { cn } from "../../lib/utils";
import logo from '../../crino_logo_1.svg';

const sizeMap = {
  sm: "max-w-sm",
  md: "max-w-md",
  lg: "max-w-lg",
  xl: "max-w-xl",
  "2xl": "max-w-2xl",
  "3xl": "max-w-3xl",
  "4xl": "max-w-4xl",
};

const Dialog = ({
  isOpen,
  onClose,
  title,
  subtitle,
  buttonLabel,
  onButtonClick,
  footerActions,
  children,
  size = "xl",
  closeOnOverlayClick = false,
  contentClassName = "",
  overlayClassName = "",
  bodyClassName = "",
  footerClassName = "",
  stickyFooter = false,
}) => {
  if (!isOpen) return null;

  const widthClass = sizeMap[size] || sizeMap["xl"];

  return (
    <div
      className={cn(
        "fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4 sm:p-6",
        overlayClassName
      )}
      onClick={closeOnOverlayClick ? onClose : undefined}
    >
      <div
        className={cn(
          "text-left bg-white rounded-lg shadow-xl w-full max-h-[calc(100vh-2rem)] sm:max-h-[calc(100vh-3rem)] relative",
          stickyFooter ? "flex flex-col overflow-hidden" : "overflow-y-auto p-6 pb-16",
          widthClass,
          contentClassName
        )}
        onClick={(event) => event.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="cursor-pointer absolute top-4 right-4 text-gray-400 hover:text-gray-600 focus:outline-none"
        >
          &#10005;
        </button>

        {stickyFooter ? (
          <>
            <div className={cn("min-h-0 flex-1 overflow-y-auto p-6 pb-4", bodyClassName)}>
              {title && (
                <h2 className="mb-6 text-2xl font-semibold text-gray-900">
                  {title}
                </h2>
              )}

              {subtitle && (
                <p className="text-lg text-gray-500 mb-12">
                  {subtitle}
                </p>
              )}

              <div>{children}</div>
            </div>

            <div
              className={cn(
                "flex flex-shrink-0 items-end justify-between gap-4 border-t border-stone-200 bg-white px-6 py-4",
                footerClassName
              )}
            >
              <img
                src={logo}
                alt=""
                aria-hidden="true"
                loading="lazy"
                className="rounded-full ring ring-stone-400 h-8 w-8 object-contain pointer-events-none select-none opacity-90"
              />

              {footerActions ? (
                footerActions
              ) : buttonLabel ? (
                <Button
                  onClick={onButtonClick || onClose}
                  variant="outline"
                  size="sm"
                >
                  {buttonLabel}
                </Button>
              ) : (
                <span />
              )}
            </div>
          </>
        ) : (
          <>
            {title && (
              <h2 className="mb-6 text-2xl font-semibold text-gray-900">
                {title}
              </h2>
            )}

            {subtitle && (
              <p className="text-lg text-gray-500 mb-12">
                {subtitle}
              </p>
            )}

            <div>{children}</div>

            {footerActions ? (
              <div className="mt-12 flex items-end justify-between gap-4">
                <img
                  src={logo}
                  alt=""
                  aria-hidden="true"
                  loading="lazy"
                  className="rounded-full ring ring-stone-400 h-8 w-8 object-contain pointer-events-none select-none opacity-90"
                />
                {footerActions}
              </div>
            ) : (
              <>
                {buttonLabel && (
                  <div className="flex justify-end">
                    <Button
                      onClick={onButtonClick || onClose}
                      variant="outline"
                      size="sm"
                      className="mt-12"
                    >
                      {buttonLabel}
                    </Button>
                  </div>
                )}

                <img
                  src={logo}
                  alt=""
                  aria-hidden="true"
                  loading="lazy"
                  className="rounded-full ring ring-stone-400 absolute bottom-6 left-6 h-8 w-8 object-contain pointer-events-none select-none opacity-90"
                />
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export { Dialog };
